module.exports = __webpack_public_path__ + "media/images/users/registrations/flow-3-b9ba32118ecfa21bd2f056d5818abb80.png";